export default class StepValues {
  constructor(minVal, maxVal, stepVal, totalWidth) {
    this._vals = this._setVals(minVal, maxVal, stepVal, totalWidth)
  }

  /**
   * This function is to grab the corresponding value based on the current position of the dot
   *
   * @param {number} widthTravelled - total width away from the left most point of the slider element
   * @returns {number} corresponding step value
   */
  getCurrentVal(widthTravelled) {
    // - 1 because .width is the lowest px value for the new step. We need the previous one
    let ind = this._vals.findIndex((obj) => widthTravelled < obj.width) - 1
    if (ind < 0) ind = 0

    return this._vals[ind].val
  }

  /**
   * This function is to grab the corresponding width based on the current value of the dot
   *
   * @param {number} val - value at a step
   * @returns {number} corresponding step value
   */
  getCurrentWidth(val) {
    let ind = this._vals.findIndex((obj) => val < obj.val) - 1

    if (ind < 0) {
      if (val < this._vals[0].val) {
        ind = 0
      } else {
        ind = this._vals.length - 1
      }
    }

    // Start: Rounding to nearest point based on the value
    const item = this._vals[ind]
    let itemNext =
      ind + 1 >= this._vals.length
        ? this._vals[this._vals.length - 1]
        : this._vals[ind + 1]

    const diffItemPrev = val - item.val
    const diffItemNext = (itemNext.val || 0) - val

    if (diffItemPrev > diffItemNext) {
      if (itemNext.val === this._vals[this._vals.length - 2].val) {
        itemNext = this._vals[this._vals.length - 1]
      }
      return itemNext.width + 1
    } else {
      return item.width + 1
    }
    // End: Rounding to nearest
  }

  /**
   * This function is to construct the list of values at each step and the corresponding minimum width from the left most point
   * Basically means if the dot crosses the min width set here, it will be the corresponding step value
   *
   * @param {number} minVal - minimum value (from props)
   * @param {number} maxVal - maximum value (from props)
   * @param {number} stepVal - step (from props)
   * @param {number} totalWidth - total width of the range slider line
   * @returns {Array} Array of objects. Please refer to the specs to see the kind of data. Structure wise:
   *  [{
   *    val: val to be displayed
   *    width: min width for this value to be taken
   *  }]
   */
  _setVals(minVal, maxVal, stepVal, totalWidth) {
    const startVal = minVal
    const endVal = maxVal
    const step = stepVal
    let arr = []
    for (let i = startVal; i <= endVal; i += step) {
      arr.push({
        // This is to prevent cases of 120.67 + 10 = 130.67000000000002
        // hence it can lead to wrong result in getCurrentWidth comparison
        val: Number(i.toFixed(2))
      })
    }

    if (arr[arr.length - 1].val !== endVal) {
      arr.push({
        val: Number(endVal.toFixed(2))
      })
    }

    const eleStepVal = totalWidth / arr.length
    arr = arr.map((obj, ind) => {
      const width = Number((eleStepVal * ind).toFixed(2))
      return {
        ...obj,
        width
      }
    })
    arr.push({ width: totalWidth + 1 })
    return arr
  }
}
